import Views from "@/views";
import Layout from "@/components/Layouts/Index.vue";

/* Views */
const { enrollments, enrollmentDetail, enrollmentGroup } = Views;

const enrollmentRouter = {
  path: "/enrollment",
  component: Layout,
  redirect: "dashboard",
  name: "",
  history: false,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "enrollments",
      name: "Enrollments",
      component: enrollments,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "enrollment-individual/:Id?",
      name: "EnrollmentIndividual",
      component: enrollmentDetail,
      hidden: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "enrollment-group",
      name: "EnrollmentGroup",
      component: enrollmentGroup,
      hidden: true,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};
export default enrollmentRouter;
